"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StageAndSavePortalSetting = exports.StageAndSavePortalSettingActionTypes = exports.SavePortalSetting = exports.SavePortalSettingActionTypes = exports.loadPortalSettings = exports.FetchPortalSettings = exports.FetchPortalSettingsActionTypes = exports.PortalSettingsActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-lib/utils/actions");

var _createAction = _interopRequireDefault(require("flux-actions/createAction"));

var PortalSettingsActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_PORTAL_SETTINGS: null,
  SAVE_PORTAL_SETTING: null,
  STAGE_PORTAL_SETTING: null,
  STAGE_AND_SAVE_PORTAL_SETTING: null,
  UNSTAGE_PORTAL_SETTING: null
}, 'settings-content-modals');
exports.PortalSettingsActionTypes = PortalSettingsActionTypes;
var FetchPortalSettingsActionTypes = (0, _actions.createRequestTypes)(PortalSettingsActionTypes.FETCH_PORTAL_SETTINGS);
exports.FetchPortalSettingsActionTypes = FetchPortalSettingsActionTypes;
var FetchPortalSettings = (0, _actions.createRequestActions)(FetchPortalSettingsActionTypes);
exports.FetchPortalSettings = FetchPortalSettings;
var loadPortalSettings = (0, _createAction.default)(PortalSettingsActionTypes.FETCH_PORTAL_SETTINGS);
exports.loadPortalSettings = loadPortalSettings;
var SavePortalSettingActionTypes = (0, _actions.createRequestTypes)(PortalSettingsActionTypes.SAVE_PORTAL_SETTING);
exports.SavePortalSettingActionTypes = SavePortalSettingActionTypes;
var SavePortalSetting = (0, _actions.createRequestActions)(SavePortalSettingActionTypes);
exports.SavePortalSetting = SavePortalSetting;
var StageAndSavePortalSettingActionTypes = (0, _actions.createRequestTypes)(PortalSettingsActionTypes.STAGE_AND_SAVE_PORTAL_SETTING);
exports.StageAndSavePortalSettingActionTypes = StageAndSavePortalSettingActionTypes;
var StageAndSavePortalSetting = (0, _actions.createRequestActions)(StageAndSavePortalSettingActionTypes);
exports.StageAndSavePortalSetting = StageAndSavePortalSetting;